export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="flex h-16 w-full items-center justify-center bg-[#efe4dc]">
      <p>© {year} - Carne de Sol do Edu</p>
    </footer>
  );
}
